export const customKeyTypes = {
  participant: 'participant',
  event: 'event',
}
